
<template>
  <div class="chart-container">
    <div class="chart" ref="chart"></div>
    <!-- 底座背景 -->
    <!-- <div class="bg"></div> -->
  </div>
</template>
 
<script>
import * as echarts from "echarts";
import API from "../api/index";

import "echarts-gl";
import { getPie3D, getParametricEquation } from "../config/charts.js"; //工具类js，页面路径自己修改
const color = ["#5AF3B8", "#93DBFF", "#4D74FF", "#FFD982", "#DFD982"];
import myMixins from "../config/mixins.js";
export default {
  name: "chart",
  mixins: [myMixins],
  data() {
    return {
      optionData: [
        {
          name: "工作人员",
          value: 0,
        },
        {
          name: "访客",
          value: 0,
        },
        {
          name: "安保人员",
          value: 1,
        },
        {
          name: "保洁人员",
          value: 1,
        },
      ],
      statusChart: null,
      option: {},
      resData: {},
      total: 0,
    };
  },
  created() {
    // this.setLabel();
  },
  mounted() {
    // this.initChart();

    //根据窗口变化自动调节图表大小
    const that = this;

    that.getPersonTypeData().then((res) => {
      that.setLabel();
      that.initChart();
    });
    window.onresize = function () {
      that.changeSize();
    };
  },
  methods: {
    //人员类型
    getPersonTypeData() {
      this.optionData = [];
      this.total = 0;
      return new Promise((resolve, reject) => {
        this.$fetch(API.statPersonnelByPersonnelMark, {}).then((res) => {
          if (res.success) {
            for (let key in res.returnObj) {
              this.optionData.push({
                name: key,
                value: res.returnObj[key],
              });
              this.total = this.total + res.returnObj[key];
            }
            // res.returnObj.forEach((item) => {
            //   console.log(item, ">>>>>item");
            // });
            console.log(this.optionData);
            resolve(res.returnObj);
          }
        });
      });
    },
    // 初始化label样式
    setLabel() {
      this.optionData.forEach((item, index) => {
        item.itemStyle = {
          color: color[index],
        };

        item.label = {
          normal: {
            show: false,
            color: color[index],
            position: "right",
            // distance:-10,
            offset: [0, 3],
            rich: {
              b: {
                // color: '#fff',
                lineHeight: 25,
                align: "left",
                color: color[index],
              },
              c: {
                fontSize: 18,
                // color: '#fff',
                textShadowColor: "#1c90a6",
                textShadowOffsetX: 0,
                textShadowOffsetY: 2,
                textShadowBlur: 5,
                color: color[index],
              },
              d: {
                color: color[index],
                align: "left",
              },
            },
          },
        };
        // item.series = [
        //   {
        //     name: "信用评价", //自己根据场景修改
        //     backgroundColor: "transparent",
        //     type: "pie",
        //     label: {
        //       opacity: 1,
        //       fontSize: 13,
        //       lineHeight: 20,
        //     },

        //     startAngle: -40, // 起始角度，支持范围[0, 360]。
        //     clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        //     radius: ["10%", "20%"],
        //     left: "10px",
        //     // center: ["0%", "50%"],
        //     data: this.optionData,
        //     itemStyle: {
        //       opacity: 0, //这里必须是0，不然2d的图会覆盖在表面
        //     },
        //   },
        // ];
        item.labelLine = {
          normal: {
            show: false,
            // length2: 30,
            // lineStyle: {
            //   width: 1,
            //   color: color[index],
            // },
          },
        };
      });
    },
    // 图表初始化
    initChart() {
      this.statusChart = echarts.init(this.$refs.chart);
      // 传入数据生成 option, 构建3d饼状图, 参数工具文件已经备注的很详细
      //   this.option = getPie3D(this.optionData, 0.6, 180, 26, 18, 1);
      this.option = getPie3D(this.optionData, 0.8, 260, 38, 2, 0.7);
      // this.option = getPie3D(this.optionData, 0.8, 260, 28, 12, 0.7);
      this.option.title = {
        text: "当前在园人数",
        left: "30%",

        bottom: 10,
        textStyle: {
          color: "#FFFFFF",
          fontSize: 16,
        },
      };
      let data = this.optionData;
      this.option.legend = {
        orient: "vertical",
        //   icon: "circle",
        top: "20%",
        right: "5%",
        itemGap: 18,
        itemWidth: 10,
        itemHeight: 10,
        formatter: function (name) {
          // let data = option.series[0].data;
          let tarValue = 0;
          for (let i = 0; i < data.length; i++) {
            if (data[i].name === name) {
              tarValue = data[i].value;
            }
          }
          let arr = [name + " " + tarValue];
          return arr.join("\n");
        },
        // formatter: function (name) {
        //   // let self = this;
        //   console.log(this, name, ">>>");
        //   let tarValue = 0;
        //   for (let i = 0; i < this.optionData.length; i++) {
        //     if (this.optionData[i].name === name) {
        //       tarValue = this.optionData[i].value;
        //     }
        //   }
        //   let arr = [name + " " + tarValue];
        //   return arr.join("\n");
        // },
        //   orient: "",
        textStyle: {
          color: "#FFFFFF",
        },
      };
      this.option.graphic = [
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center", //
          top: "45%",
          width: 100,

          // background: "red",
          // fill: "red",
          style: {
            text: this.total,
            textAlign: "center",
            fill: "#fff", //文字的颜色
            fontSize: 36,
            width: 100,
            lineHeight: 16,
          },
        },
      ];
      //   this.statusChart.setOption(this.option);
      // 是否需要label指引线，如果要就添加一个透明的2d饼状图并调整角度使得labelLine和3d的饼状图对齐，并再次setOption
      this.option.series.push({
        name: "信用评价", //自己根据场景修改
        backgroundColor: "transparent",
        type: "pie",
        label: {
          opacity: 1,
          fontSize: 13,
          lineHeight: 20,
          show: false,
        },

        startAngle: -40, // 起始角度，支持范围[0, 360]。
        clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ["10%", "20%"],

        // center: ["0%", "50%"],
        data: this.optionData,
        itemStyle: {
          opacity: 0, //这里必须是0，不然2d的图会覆盖在表面
        },
      });
      this.statusChart.setOption(this.option);
      this.bindListen(this.statusChart);
    },
    // bindListen(myChart, optionName = "option") {
    //   console.log(myChart, ">>>>mychart");
    //   let selectedIndex = "";
    //   let hoveredIndex = "";
    //   // 监听点击事件，实现选中效果（单选）
    //   myChart.on("click", (params) => {
    //     console.log(
    //       this[optionName].series[params.seriesIndex],
    //       "this[optionName].series[params.seriesIndex].pieStatus"
    //     );
    //     // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
    //     const isSelected =
    //       !this[optionName].series[params.seriesIndex].pieStatus.selected;
    //     const isHovered =
    //       this[optionName].series[params.seriesIndex].pieStatus.hovered;
    //     const k = this[optionName].series[params.seriesIndex].pieStatus.k;
    //     const startRatio =
    //       this[optionName].series[params.seriesIndex].pieData.startRatio;
    //     const endRatio =
    //       this[optionName].series[params.seriesIndex].pieData.endRatio;
    //     // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
    //     if (selectedIndex !== "" && selectedIndex !== params.seriesIndex) {
    //       this[optionName].series[selectedIndex].parametricEquation =
    //         getParametricEquation(
    //           this[optionName].series[selectedIndex].pieData.startRatio,
    //           this[optionName].series[selectedIndex].pieData.endRatio,
    //           false,
    //           false,
    //           k,
    //           this[optionName].series[selectedIndex].pieData.value
    //         );
    //       this[optionName].series[selectedIndex].pieStatus.selected = false;
    //     }
    //     // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
    //     this[optionName].series[params.seriesIndex].parametricEquation =
    //       getParametricEquation(
    //         startRatio,
    //         endRatio,
    //         isSelected,
    //         isHovered,
    //         k,
    //         this[optionName].series[params.seriesIndex].pieData.value
    //       );
    //     this[optionName].series[params.seriesIndex].pieStatus.selected =
    //       isSelected;
    //     // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
    //     selectedIndex = isSelected ? params.seriesIndex : null;
    //     // 使用更新后的 option，渲染图表
    //     myChart.setOption(this[optionName]);
    //   });
    //   // 监听 mouseover，近似实现高亮（放大）效果
    //   myChart.on("mouseover", (params) => {
    //     // 准备重新渲染扇形所需的参数
    //     let isSelected;
    //     let isHovered;
    //     let startRatio;
    //     let endRatio;
    //     let k;
    //     // 如果触发 mouseover 的扇形当前已高亮，则不做操作
    //     if (hoveredIndex === params.seriesIndex) {
    //       // 否则进行高亮及必要的取消高亮操作
    //     } else {
    //       // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
    //       if (hoveredIndex !== "") {
    //         // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
    //         isSelected =
    //           this[optionName].series[hoveredIndex].pieStatus.selected;
    //         isHovered = false;
    //         startRatio =
    //           this[optionName].series[hoveredIndex].pieData.startRatio;
    //         endRatio = this[optionName].series[hoveredIndex].pieData.endRatio;
    //         k = this[optionName].series[hoveredIndex].pieStatus.k;
    //         // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
    //         this[optionName].series[hoveredIndex].parametricEquation =
    //           getParametricEquation(
    //             startRatio,
    //             endRatio,
    //             isSelected,
    //             isHovered,
    //             k,
    //             this[optionName].series[hoveredIndex].pieData.value
    //           );
    //         this[optionName].series[hoveredIndex].pieStatus.hovered = isHovered;
    //         // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
    //         hoveredIndex = "";
    //       }
    //       // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
    //       if (
    //         params.seriesName !== "mouseoutSeries" &&
    //         params.seriesName !== "信用评价"
    //       ) {
    //         // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
    //         isSelected =
    //           this[optionName].series[params.seriesIndex].pieStatus.selected;
    //         isHovered = true;
    //         startRatio =
    //           this[optionName].series[params.seriesIndex].pieData.startRatio;
    //         endRatio =
    //           this[optionName].series[params.seriesIndex].pieData.endRatio;
    //         k = this[optionName].series[params.seriesIndex].pieStatus.k;
    //         // 对当前点击的扇形，执行高亮操作（对 option 更新）
    //         this[optionName].series[params.seriesIndex].parametricEquation =
    //           getParametricEquation(
    //             startRatio,
    //             endRatio,
    //             isSelected,
    //             isHovered,
    //             k,
    //             this[optionName].series[params.seriesIndex].pieData.value + 60
    //           );
    //         this[optionName].series[params.seriesIndex].pieStatus.hovered =
    //           isHovered;
    //         // 记录上次高亮的扇形对应的系列号 seriesIndex
    //         hoveredIndex = params.seriesIndex;
    //       }
    //       // 使用更新后的 option，渲染图表
    //       myChart.setOption(this[optionName]);
    //     }
    //   });
    //   // 修正取消高亮失败的 bug
    //   myChart.on("globalout", () => {
    //     // 准备重新渲染扇形所需的参数
    //     let isSelected;
    //     let isHovered;
    //     let startRatio;
    //     let endRatio;
    //     let k;
    //     if (hoveredIndex !== "") {
    //       // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
    //       isSelected = this[optionName].series[hoveredIndex].pieStatus.selected;
    //       isHovered = false;
    //       k = this[optionName].series[hoveredIndex].pieStatus.k;
    //       startRatio = this[optionName].series[hoveredIndex].pieData.startRatio;
    //       endRatio = this[optionName].series[hoveredIndex].pieData.endRatio;
    //       // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
    //       this[optionName].series[hoveredIndex].parametricEquation =
    //         getParametricEquation(
    //           startRatio,
    //           endRatio,
    //           isSelected,
    //           isHovered,
    //           k,
    //           this[optionName].series[hoveredIndex].pieData.value
    //         );
    //       this[optionName].series[hoveredIndex].pieStatus.hovered = isHovered;
    //       // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
    //       hoveredIndex = "";
    //     }
    //     // 使用更新后的 option，渲染图表
    //     myChart.setOption(this[optionName]);
    //   });
    // },
    // 自适应宽高
    changeSize() {
      this.statusChart.resize();
    },
  },
};
</script>
 
<style lang='scss' scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
  .chart {
    z-index: 1;
  }
  .chart,
  .bg {
    width: 100%;
    height: 100%;
  }

  .bg {
    position: absolute;
    bottom: -10px;
    left: 50%;
    z-index: 0;
    height: calc(200 / 1080 * 100vh);
    width: calc(240 / 1920 * 100vw);
    background: no-repeat center;
    // background-image: url("~@/assets/imgs/piebg.png");
    background-size: 100% 100%;
    transform: translateX(-50%);
  }
}
</style>


